import React, {
  useState,
  useContext,
  useRef,
  useEffect,
  useCallback,
} from "react";
//import DatePicker from "react-bootstrap-date-picker";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Form, Button, Container, Row, Col, InputGroup } from "react-bootstrap";
import { LanguageContext } from "../contexts/LanguageContext";
//import "bootstrap/dist/css/bootstrap.css";
import { postData } from "../services/guestService";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../contexts/AuthContext";
import { CarrierContext } from "../contexts/CarrierContext";
//import { post } from "jquery";
import { v4 as uuidv4, validate } from "uuid";
//import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import { Spinner } from "react-bootstrap";
//import Toast from "./Toast";
import { Popover, OverlayTrigger } from "react-bootstrap";
import "../assets/css/Login.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LogContext } from "../contexts/LogContext";
import { dompurifyInput } from "../utils/sanitizeInput";

// Mobile Breakpoint Constant (phones only, excludes tablets)
const MOBILE_BREAKPOINT = 767;

export default function Login() {
  const { cmsAllPages, handleLanguage, langErr } = useContext(LanguageContext);
  const [cms, setLoginCMS] = useState("");
  const baseUrl = process.env.PUBLIC_URL;

  const { Log } = useContext(LogContext);

  var currentDate = new Date();
  currentDate = `${
    currentDate.getUTCMonth() + 1
  }-${currentDate.getUTCDate()}-${currentDate.getUTCFullYear()}`;
  const [memberId, setMemberId] = useState("");
  const [dob, setDOB] = useState("");
  const [zip, setZip] = useState("");
  const [agree, setAgree] = useState(true);

  const [showDateErr, setShowDateErr] = useState("hide-date-err");
  const [showErr, setShowErr] = useState("hide-err");
  const [errorText, setErrorText] = useState("");
  const [inputInvalidStyle, setInputInvalidStyle] = useState("");
  const [labelSignIn, setLabelSignIn] = useState("");
  const [ssnMemberIdErr, setSSNMemberIdErr] = useState("");
  const [zipErr, setZipErr] = useState("");

  const [accessToken, setAccessToken] = useState("");
  const [expiresAt, setExpiresAt] = useState("");

  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(() => {
    const storedLang = sessionStorage.getItem("langSel");
    return storedLang ? storedLang : "eng"; // Use stored value if present, else default to 'eng'
  });
  /* Toast Message - To show alert */
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState(""); // To track toast type (error or success)
  const [loginPayload, setLoginPayLoad] = useState([]);
  const [showPopover, setShowPopover] = useState(false);
  const popoverRef = useRef(null);
  const popoverTriggerRef = useRef(null);
  const popoverHeaderRef = useRef(null); // Ref for the popover header
  const popoverBodyRef = useRef(null); // Ref for the popover header
  //For login onchange tickmark
  const [isMemberIdValid, setIsMemberIdValid] = useState(false);
  const [memberIdTouched, setMemberIdTouched] = useState(false);
  const [isDOBValid, setIsDOBValid] = useState(false);
  const [dobTouched, setDOBTouched] = useState(false);
  const [isZipValid, setIsZipValid] = useState(false);
  const [zipTouched, setZipTouched] = useState(false);
  const mainLoginContentsRef = useRef(null);
  const handlePopoverToggle = () => setShowPopover((prev) => !prev);
  const handleClickOutside = (event) => {
    // Check if the clicked target is inside the popover header or body
    if (
      popoverRef.current && // Popover content is present
      !popoverRef.current.contains(event.target) && // Click is not inside the popover content
      popoverTriggerRef.current && // Popover trigger (h5) is present
      !popoverTriggerRef.current.contains(event.target) && // Click is not inside the trigger (h5)
      popoverHeaderRef.current && // Popover header is present
      !popoverHeaderRef.current.contains(event.target) && // Click is not inside the popover header
      popoverBodyRef.current && // Popover header is present
      !popoverBodyRef.current.contains(event.target) // Click is not inside the popover header
    ) {
      setShowPopover(false); // Close the popover
    }
    if (
      popoverHeaderRef.current && // Popover header is present
      !popoverHeaderRef.current.contains(event.target) && // Click is not inside the popover header
      popoverBodyRef.current && // Popover header is present
      !popoverBodyRef.current.contains(event.target)
    ) {
      // Click is not inside the popover header
      setShowPopover(false); // Close the popover
    }
  };

  // Set up event listener to close popover when clicking outside
  useEffect(() => {
    // Add the event listener only if popoverRef is valid

    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  /* useEffect(() => {
    if (showPopover && popoverRef.current) {
      popoverRef.current.focus(); // Set focus to the Popover
    }
  }, [showPopover]);*/
  /* Added the below code for fixing 508 compliance of NVDA not reading popover on time of render -st67393 */
  useEffect(() => {
    if (showPopover) {
      const tryFocusPopover = () => {
        const popoverEl = document.getElementById("popover-custom");
        if (popoverEl) {
          popoverEl.focus();
        } else {
          // Retry until it's rendered (React-Bootstrap portal delay)
          setTimeout(tryFocusPopover, 50);
        }
      };
      tryFocusPopover();
    }
  }, [showPopover]);

  const carrierContxt = useContext(CarrierContext);
  const urlCarrier = carrierContxt.hasOwnProperty("carrier")
    ? carrierContxt.carrier
    : null;
  const { login } = useAuth();

  const navigate = useNavigate();
  // Check if current carrier is excluded for carousel
  const carouselExcludedCarriers = (
      process.env.REACT_APP_CAROUSEL_EXCLUDED_CARRIERS || ""
  )
      .split(",")
      .map((c) => c.trim().toLowerCase());

  const isCarouselExcluded = carouselExcludedCarriers.includes(
      urlCarrier?.toLowerCase()
  );

  /* const handleAccessToken = (token, expiresIn) => {
    setAccessToken(token);
    const expirationTime = Date.now() + expiresIn * 1000; // Convert expiresin seconds to milliseconds and add up
    setExpiresAt(expirationTime);
  };*/

  useEffect(() => {
    if (!sessionStorage.getItem("langSel")) {
      sessionStorage.setItem("langSel", "eng");
    }
  }, []);
  useEffect(() => {
    if (cmsAllPages && cmsAllPages.login) {
      setLoginCMS(cmsAllPages.login);
    }

    setLabelSignIn(cms && cms.label_signin ? cms.label_signin : "");

    /* if (langErr) {
      setErrorText(langErr);
      /*setShowErr("show-err");*/
    /* }*/
    if (errorText) {
      setShowErr("show-err");
    } else {
      setShowErr("hide-err");
    }
  }, [cmsAllPages, langErr, errorText, cms, showErr]);

  //Toast notification
  useEffect(() => {
    if (errorText) {
      toast.error(errorText);
      // setErrorText("");
    }
  }, [errorText]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (mainLoginContentsRef.current) {
        mainLoginContentsRef.current.focus();
      }
    }, 1000); // Delay to ensure the DOM is fully rendered

    return () => clearTimeout(timer); // Cleanup the timer
  }, []);
  /* OAUTH Request before login API */
  /*const oauthCall = useCallback(async () => {
    setLoading(true);
    const oauthPayload = {
      client_id: process.env.REACT_APP_CLIENT_ID,
      client_secret: process.env.REACT_APP_CLIENT_SECRET,
      grant_type: "client_credentials",
      scope: "default",
    };
    postData("hps-oauth-cc/oauth2/token", new URLSearchParams(oauthPayload), {
      "Content-Type": "application/x-www-form-urlencoded",
    })
      .then((result) => {
        if (result.status === 200) {
          const response = result.data;

          if (response.access_token && response.expires_in) {
            handleAccessToken(response.access_token, response.expires_in);
          } else {
            setErrorText("OAUTH: T0: " + cms.err_login_tech_err);
          }
        } else {
          const errorTxt = "OAUTH: " + result.status;
          var resultErr = "";
          if (result.error) {
            resultErr = result.error;
          }
          if (result.errors && result.errors.text) {
            resultErr += result.errors.text;
          }
          setErrorText(errorTxt + cms.err_login_tech_err + " : " + resultErr);
        }
      })
      .catch((error) => {
        if (error.response) {
          // The request was made and the server responded with a status code
          setErrorText(
            "OAUTH ERR: " +
              cms.err_login_tech_err +
              " : " +
              error.response.status +
              " : " +
              error.response
          );
        } else if (error.request) {
          // The request was made but no response was received
          setErrorText(
            "OAUTH ERR: " + cms.err_login_tech_err + " : " + error.request
          );
        } else {
          // Something happened in setting up the request that triggered an Error
          setErrorText(
            "OAUTH ERR: " + cms.err_login_tech_err + " : " + error.message
          );
        }
      })
      .finally(() => {
        // Code that runs regardless of success or failure
        setLoading(false);
      });
  }, [cms]);

  /* Make Payload */
  /*useEffect(() => {
    console.log("Updated loginPayload:", loginPayload);
  }, [loginPayload]);*/

  const makePayload = useCallback(async () => {
    const formatDate = (date) => {
      if (!date) return "";
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-indexed
      const day = String(date.getUTCDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const memberIdKey =
      memberId.length > 4 ? "carrierSubscriberId" : "last4OfSSN";
    const dobDate = formatDate(dob);

    const payload = {
      zip: zip,
      dateOfBirth: dobDate,
      [memberIdKey]: memberId,
    };

    setLoginPayLoad(payload);
  }, [dob, memberId, zip]);
  /* Make Payload */
  /* Login API */
  const loginGuest = useCallback(async () => {
    setLoading(true);
    // makePayload();
    const formatDate = (date) => {
      if (!date) return "";
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    const memberIdKey =
      memberId.length > 4 ? "carrierSubscriberId" : "last4OfSSN";
    const dobDate = formatDate(dob);
    const payload = new FormData();

    // Append your form fields to FormData
    payload.append("zip", dompurifyInput(zip));
    payload.append("dateOfBirth", dobDate); // Assuming dob is a string or formatted date
    payload.append([memberIdKey], dompurifyInput(memberId)); // Assuming memberId is a string
    /* const payload = {
      zip: zip,
      dateOfBirth: dobDate,
      [memberIdKey]: memberId,
    };*/
    // console.log(payload);

    const carr_code = "REACT_APP_" + urlCarrier.toUpperCase();
    const carr_code_val = process.env[carr_code];
    const login_client_id = "REACT_APP_LOGIN_API_CLIENT_ID_" + carr_code_val;
    const login_client_secret =
      "REACT_APP_LOGIN_API_CLIENT_SECRET_" + carr_code_val;
    const guid = uuidv4();
    const headers = {
      "X-Hps-Trace-Id": guid,
      "X-Hps-Ts": Date.now(),
      "X-Hps-Carrier-Code": process.env[carr_code],
      "X-Hps-Sender-Id": "GUEST PAYMENT PORTAL",
      "X-Hps-SiteCd": process.env[carr_code] + "GPT",
      "X-Hps-Client-Id": process.env[login_client_id],
      "X-Hps-Secret-Id": process.env[login_client_secret],
      "X-Hps-Db-Region": process.env.REACT_APP_REGION,
    };
    if (payload) {
      //Combine payload and headers for log API
      // Convert FormData to a plain JavaScript object
      function formDataToObject(formData) {
        const obj = {};
        formData.forEach((value, key) => {
          obj[key] = value;
        });
        return obj;
      }

      // Combine payload and headers
      const combinePayloadAndHeaders = (payload, headers) => {
        const payloadObject = formDataToObject(payload);

        // Combine payload and headers
        const combined = {
          payload: payloadObject,
          headers: headers,
        };

        return JSON.stringify(combined, null, 2); // Pretty print the JSON (optional)
      };
      const request_to_log = combinePayloadAndHeaders(payload, headers);
      postData(
        process.env.REACT_APP_API_HTTP_URL + process.env.REACT_APP_API_PATH,
        process.env.REACT_APP_LOGIN_API_ENDPOINT,
        payload,
        headers
      )
        .then((result) => {
          if (result) {
            if (result.status && result.data && result.status === 200) {
              const response = result.data;

              if (!response.error) {
                /*  const encryptedData = encryptLogindata(
                  JSON.stringify(response)
                );*/

                /* Cookies.set("case_d", encryptedData, {
                  secure: true,
                  httpOnly: true,
                  sameSite: "strict",
                });*/

                if (response.status_code === "HPS200") {
                  //API success
                  if (response.payment_info) {
                    if (response.payment_info.multipleMatchRecord) {
                      //API not success-SSN passed
                      Log(
                        "Login",
                        "API",
                        response?.payment_info?.caseInfo[0]?.caseNum,
                        "Multiple policies found.Try with member id.",
                        "ERROR",
                        request_to_log,
                        result,
                        process.env.REACT_APP_API_HTTP_URL +
                          process.env.REACT_APP_API_PATH +
                          process.env.REACT_APP_LOGIN_API_ENDPOINT,
                        "F"
                      );
                      setMemberId("");
                      setSSNMemberIdErr(cms.invalid_memberid);
                      setErrorText(cms.err_login_multiple);
                    } else {
                      login(response);
                      Log(
                        "Login",
                        "API",
                        response?.payment_info?.caseInfo[0]?.caseNum,
                        "Logged in successfully",
                        "INFO",
                        request_to_log,
                        result,
                        process.env.REACT_APP_API_HTTP_URL +
                          process.env.REACT_APP_API_PATH +
                          process.env.REACT_APP_LOGIN_API_ENDPOINT,
                        "S"
                      );
                      navigate("/" + urlCarrier + "/makepayment");
                    }
                  } else {
                    Log(
                      "Login",
                      "API",
                      "",
                      "User not found. Payment info is missing in response",
                      "ERROR",
                      request_to_log,
                      result,
                      process.env.REACT_APP_API_HTTP_URL +
                        process.env.REACT_APP_API_PATH +
                        process.env.REACT_APP_LOGIN_API_ENDPOINT,
                      "F"
                    );
                    setErrorText(cms.err_login_not_found);
                  }
                } else if (response.status_code === "HPS408") {
                  //Termed case login
                  Log(
                    "Login",
                    "API",
                    "",
                    "Provided case is Termed",
                    "ERROR",
                    request_to_log,
                    result,
                    process.env.REACT_APP_API_HTTP_URL +
                      process.env.REACT_APP_API_PATH +
                      process.env.REACT_APP_LOGIN_API_ENDPOINT,
                    "F"
                  );
                  setErrorText(cms?.err_login_termed_case);
                } else if (memberId.length <= 4) {
                  //API not success-SSN passed
                  Log(
                    "Login",
                    "API",
                    "",
                    "User not found on login with SSN.Try with member id.",
                    "ERROR",
                    request_to_log,
                    result,
                    process.env.REACT_APP_API_HTTP_URL +
                      process.env.REACT_APP_API_PATH +
                      process.env.REACT_APP_LOGIN_API_ENDPOINT,
                    "F"
                  );
                  setMemberId("");
                  setSSNMemberIdErr(cms.invalid_memberid);
                  setErrorText(cms.err_login_not_found_on_ssn);
                } else {
                  //API not success-Member id passed
                  Log(
                    "Login",
                    "API",
                    "",
                    "User not found on trying with member id",
                    "ERROR",
                    request_to_log,
                    result,
                    process.env.REACT_APP_API_HTTP_URL +
                      process.env.REACT_APP_API_PATH +
                      process.env.REACT_APP_LOGIN_API_ENDPOINT,
                    "F"
                  );
                  setErrorText(cms.err_login_not_found);
                }
              } else {
                Log(
                  "Login",
                  "API",
                  "",
                  "Login API failed",
                  "ERROR",
                  request_to_log,
                  result,
                  process.env.REACT_APP_API_HTTP_URL +
                    process.env.REACT_APP_API_PATH +
                    process.env.REACT_APP_LOGIN_API_ENDPOINT,
                  "F"
                );
                const errorTxt = "Login: ";
                setErrorText(errorTxt + cms.err_login_tech_err);
              } /*else if (result.data === "multiple") {
            setMemberId("");
            setValidated(false);
            setErrorText(cms.err_login_multiple);
            setInputInvalidStyle("show-input-invalid-style");
            
          } else if (result.data === "not found") {
            setErrorText(cms.err_login_not_found);
            /* setShowErr("show-err");*/
              /* } else {
            setErrorText(cms.err_login_tech_err);
            
          }*/
            } else if (result.status === 404) {
              Log(
                "Login",
                "API",
                "",
                "Login API failed",
                "ERROR",
                request_to_log,
                result,
                process.env.REACT_APP_API_HTTP_URL +
                  process.env.REACT_APP_API_PATH +
                  process.env.REACT_APP_LOGIN_API_ENDPOINT,
                "F"
              );
              setErrorText(cms.err_login_not_found);
            } else {
              Log(
                "Login",
                "API",
                "",
                "Login API failed",
                "ERROR",
                request_to_log,
                result,
                process.env.REACT_APP_API_HTTP_URL +
                  process.env.REACT_APP_API_PATH +
                  process.env.REACT_APP_LOGIN_API_ENDPOINT,
                "F"
              );
              const errorTxt = "Login: " + result.status;
              var resultErr = "";
              if (result.error) {
                resultErr = result.error;
              }
              if (result.errors && result.errors.text) {
                resultErr += result.errors.text;
              }
              setErrorText(
                errorTxt + cms.err_login_tech_err + " : " + resultErr
              );
            }
          } else {
            Log(
              "Login",
              "API",
              "",
              "Login API failed",
              "ERROR",
              request_to_log,
              "No result found",
              process.env.REACT_APP_API_HTTP_URL +
                process.env.REACT_APP_API_PATH +
                process.env.REACT_APP_LOGIN_API_ENDPOINT,
              "F"
            );
            setErrorText(cms.err_login_tech_err);
          }
        })
        .catch((error) => {
          let error_msg = "";
          if (error.response) {
            // The request was made and the server responded with a status code
            if (error.response.status === 404) {
              error_msg = cms.err_login_not_found;
              setErrorText(error_msg);
            } else {
              error_msg =
                cms.err_login_tech_err +
                " : " +
                error?.response?.status +
                " : " +
                error?.response?.statusText;
              setErrorText(error_msg);
            }
          } else if (error.request) {
            // The request was made but no response was received
            error_msg =
              cms.err_login_tech_err +
              " : " +
              error?.request?.status +
              " : " +
              error?.request?.statusText;
            setErrorText(error_msg);
          } else {
            // Something happened in setting up the request that triggered an Error
            const errMsg = error.message ? error.message : "";
            error_msg = cms.err_login_tech_err + " : " + errMsg;
            setErrorText(error_msg);
          }

          Log(
            "Login",
            "API",
            "",
            "Exception: Login API failed",
            "ERROR",
            request_to_log,
            error_msg,
            process.env.REACT_APP_API_HTTP_URL +
              process.env.REACT_APP_API_PATH +
              process.env.REACT_APP_LOGIN_API_ENDPOINT,
            "F"
          );
        })
        .finally(() => {
          // Code that runs regardless of success or failure
          setLoading(false);
        });
    } else {
      Log(
        "Login",
        "API",
        "",
        "Login Payload is not set!",
        "ERROR",
        headers,
        "",
        process.env.REACT_APP_API_HTTP_URL +
          process.env.REACT_APP_API_PATH +
          process.env.REACT_APP_LOGIN_API_ENDPOINT,
        "F"
      );
    }
  }, [cms, login, navigate, urlCarrier, dob, memberId, zip, Log]);

  /* Call login API if access token is valid*/
  /* const isTokenValid = useCallback(() => {
    return expiresAt && Date.now() < expiresAt;
  }, [expiresAt]);*/

  /*  useEffect(() => {
    if (accessToken && expiresAt) {
      if (isTokenValid()) {
        loginGuest();
      } else {
        oauthCall();
      }
    }
  }, [accessToken, expiresAt, loginGuest, oauthCall, isTokenValid]);*/
  const formRef = useRef(null);

  const [menuToggle, setMenuToggle] = useState(false);
  const menuContainerRef = useRef(null);

  // bcbsaz Mobile Detection (phones only, excludes tablets)
  const isBcbsazCarrier = urlCarrier === 'bcbsaz';
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= MOBILE_BREAKPOINT);
  const isBcbsazMobile = isBcbsazCarrier && isMobileView;

  // Handle window resize to update mobile view state
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= MOBILE_BREAKPOINT);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleMenu = () => {
    setMenuToggle(prev => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuToggle &&
        menuContainerRef.current &&
        !menuContainerRef.current.contains(event.target)
      ) {
        const menuButton = document.querySelector('[aria-label="Open menu"]');
        if (!menuButton?.contains(event.target)) {
          setMenuToggle(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuToggle]);

  const handleMemberID = (e) => {
    setMemberId(dompurifyInput(e.target.value));
    setMemberIdTouched(true); // mark as touched
    if (!e.target.value) {
      setSSNMemberIdErr(cms.invalid_ssn_memberid);
      setIsMemberIdValid(false);
    } else if (e.target.value.length < 4) {
      setSSNMemberIdErr(cms.invalid_len_ssn_memberid);
      setIsMemberIdValid(false);
    } else {
      setSSNMemberIdErr("");
      setIsMemberIdValid(true);
    }
  };

  const handleZip = (e) => {
    setZip(dompurifyInput(e.target.value));
    setZipTouched(true); // mark as touched
    if (!e.target.value) {
      setZipErr(cms.invalid_zip);
      setIsZipValid(false);
    } else if (e.target.value.length !== 5) {
      setZipErr(cms.invalid_len_zip);
      setIsZipValid(false);
    } else {
      setZipErr("");
      setIsZipValid(true);
    }
  };

  const handleCheckBox = (e) => {
    setAgree(!agree);
  };
  const handleDOB = (date) => {
    setDOB(date);
    setDOBTouched(true); // mark as touched
    if (!date) {
      setShowDateErr("show-date-err");
      setIsDOBValid(false);
    } else {
      setShowDateErr("hide-date-err");
      setIsDOBValid(true);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setValidated(false);
    setShowErr("hide-err");
    setErrorText("");
    setInputInvalidStyle("");

    const form = event.currentTarget;

    if (form.checkValidity() === false || !dob) {
      if (!zip) {
        setZipErr(cms.invalid_zip);
      } else if (zip?.length <= 4) {
        setZipErr(cms.invalid_len_zip);
      } else {
        setZipErr("");
      }
      if (!memberId) {
        setSSNMemberIdErr(cms.invalid_ssn_memberid);
        //setSSNMemberIdErrClass("invalid");
      } else if (memberId.length < 4) {
        setSSNMemberIdErr(cms.invalid_len_ssn_memberid);
        // setSSNMemberIdErrClass("invalid");
      } else {
        setSSNMemberIdErr("");
        // setSSNMemberIdErrClass("");
      }
      if (!dob) {
        setShowDateErr("show-date-err");
      }

      //setShowToast(true);
      //(cms.invalid_field_all, "error"); //To show error toast alert
      setErrorText(cms.invalid_field_all);
      event.stopPropagation();
    } else {
      setShowDateErr("hide-date-err");
      setValidated(true);
      setErrorText("");

      //triggerToast("Success!", "success"); //To show success toast alert

      // if (accessToken && expiresAt && isTokenValid()) {
      loginGuest();
      // } else {
      //   oauthCall();
      // }
    }
    //setValidated(true);
  };

  /* const handleLanguageEn = () => {
    handleLanguage("eng");
  };

  const handleLanguageEs = () => {
    handleLanguage("spa");
  };*/
  const handleLanguageChange = (event) => {
    setSelectedLanguage(event.target.value);
    sessionStorage.setItem("langSel", event.target.value); // Store selected language
    handleLanguage(event.target.value);
  };
  /*if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }*/

  return (
    <>
    <div id="main-login-contents" ref={mainLoginContentsRef} tabIndex="-1">
      <section className="bg-pink vh-100 d-flex toggles-menu" style={{ overflowY: 'auto' }}>
        {/* Main content */}
        <h1 id="main-heading" tabIndex="-1"></h1>
        {
          /*cms && (*/
          <div className="container-fluid h-100 px-0">
            <div className="row g-0 h-100">
              <div className="col-12 px-0 h-100">
                <div className="card border-light-subtle mb-0" style={{ borderRadius: 0 }}>
                  <div className="row g-0 h-100">
                    <div
                        className={`col-12 col-md-6 overlay text-end pt-xl-3 p-3 p-sm-0 p-md-0 p-xl-0 ${
                            isCarouselExcluded
                                ? "d-flex align-items-center justify-content-center"
                                : ""
                        }`}
                    >
                      <div
                          className={`col-12 text-center ${
                              isCarouselExcluded ? "" : "mt-2"
                          }`}
                      >
                        {/* Logo*/}
                        <img
                          src={`${process.env.PUBLIC_URL}/images/carrier-logos/${urlCarrier}-login-sml.svg`}
                          width="230"
                          height="61"
                          alt={cms.carrier_logo_508_alt_text}
                          tabIndex="0"
                        />
                      </div>
                      {/* Carousel*/}
                      {!isCarouselExcluded && (
                      <div
                        id="carouselExampleDark"
                        className="carousel carousel-dark slide"
                        data-bs-ride="carousel"
                      >
                        <div className="carousel-indicators">
                          <button
                            type="button"
                            data-bs-target="#carouselExampleDark"
                            data-bs-slide-to="0"
                            className="active"
                            aria-current="true"
                            aria-label="Slide 1"
                          ></button>
                          <button
                            type="button"
                            data-bs-target="#carouselExampleDark"
                            data-bs-slide-to="1"
                            aria-label="Slide 2"
                          ></button>
                          <button
                            type="button"
                            data-bs-target="#carouselExampleDark"
                            data-bs-slide-to="2"
                            aria-label="Slide 3"
                          ></button>
                        </div>
                        <div className="carousel-inner">
                          <div
                            className="carousel-item active"
                            data-bs-interval="10000"
                          >
                            <div className="carousel-caption d-md-block px-md-5 pb-md-5 slider-size">
                              <img
                                src={`${process.env.PUBLIC_URL}/images/illustrations/${urlCarrier}-carousel-inner-slide1.svg`}
                                className="mw-90"
                                alt="carousel-item"
                              />
                            </div>
                          </div>
                          <div
                            className="carousel-item"
                            data-bs-interval="2000"
                          >
                            <div className="carousel-caption d-md-block px-md-5 pb-md-5 slider-size">
                              <img
                                src={`${process.env.PUBLIC_URL}/images/illustrations/${urlCarrier}-carousel-inner-slide2.svg`}
                                className="mw-90"
                                alt="carousel-item"
                              />
                            </div>
                          </div>
                          <div className="carousel-item">
                            <div className="carousel-caption d-md-block px-md-5 pb-md-5 slider-size">
                              <img
                                src={`${process.env.PUBLIC_URL}/images/illustrations/${urlCarrier}-carousel-inner-slide3.svg`}
                                className="mw-90"
                                alt="carousel-item"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {/* Carousel ends*/}
                    </div>

                    <div className="col-12 col-md-6 d-flex justify-content-center">
                      <div className="col-12 col-lg-11 col-xl-10">
                        <div className="card-body p-3 p-md-4 p-xl-3">
                          <div className="row">
                            <div className="col-12 d-flex align-items-center justify-content-between login-header-row">
                              {/* Contact us*/}
                              <div className="flex-shrink-0">
                                <OverlayTrigger
                                  trigger="click"
                                  placement="bottom"
                                  show={showPopover}
                                  overlay={
                                    <Popover
                                      id="popover-custom"
                                      ref={popoverRef}
                                      tabIndex="-1" // Makes the Popover focusable
                                      aria-live={showPopover ? "polite" : "off"} // Enable live region when visible
                                      onFocus={() => setShowPopover(true)} // Show Popover on focus
                                      onBlur={() => setShowPopover(false)} // Hide Popover on blur
                                      role="dialog" //508 compliance -for reading popup ontime
                                      aria-modal="false" //508 compliance -for reading popup ontime
                                      aria-labelledby="popover-header" //508 compliance -for reading popup ontime
                                      aria-describedby="popover-body" //508 compliance -for reading popup ontime
                                      aria-atomic="true" //508 compliance -for reading popup ontime
                                    >
                                      <Popover.Header
                                        as="h3"
                                        id="popover-header"
                                        ref={popoverHeaderRef}
                                      >
                                        {cms.label_contact_information}
                                      </Popover.Header>
                                      <Popover.Body
                                        ref={popoverBodyRef}
                                        id="popover-body"
                                      >
                                        {cms.label_contact_number_label}:{" "}
                                        {cms.label_contact_number_value}{" "}
                                        <br></br>
                                        {cms.label_contact_member_service_hours}
                                        : {cms.label_hours_of_operation_value}
                                      </Popover.Body>
                                    </Popover>
                                  }
                                >
                                  <div ref={popoverTriggerRef}>
                                    {" "}
                                    {/* Wrapping the trigger with the same ref */}
                                    <h5
                                      data-bs-toggle="popover"
                                      className="fw-semibold login-contact"
                                      data-bs-title="Contact information"
                                      data-bs-content={`${
                                        cms.label_contact_number_label
                                      }:${" "}${
                                        cms.label_contact_number_value
                                      } ${
                                        cms.label_contact_member_service_hours
                                      }:${" "}${
                                        cms.label_hours_of_operation_value
                                      }`}
                                      onClick={handlePopoverToggle} // Toggle popover on click
                                      aria-label={cms.label_508_contact_us}
                                      tabIndex="0"
                                      aria-flowto={
                                        showPopover
                                          ? "popover-custom"
                                          : undefined
                                      }
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                          setShowPopover((prev) => !prev); // Toggle Popover on Enter key
                                        }
                                      }}
                                    >
                                      <img
                                        src={
                                          urlCarrier === "bcbsaz"
                                            ? `${process.env.PUBLIC_URL}/images/icons/Payment/Mobile-bcbsaz.svg`
                                            : `${process.env.PUBLIC_URL}/images/icons/Payment/Mobile.svg`
                                        }
                                        className="Mobile"
                                        alt=""
                                      />
                                      &nbsp;{cms.label_contact_us}
                                    </h5>
                                  </div>
                                </OverlayTrigger>
                              </div>
                              {/* Language Dropdown + Menu Toggle */}
                              <div className="d-flex align-items-center gap-2 flex-shrink-0">
                                <select
                                  id="language"
                                  className="login-dropdown"
                                  value={selectedLanguage}
                                  onChange={handleLanguageChange}
                                  aria-label={cms.label_508_select_language}
                                >
                                  <option value="eng" className="en-flag">
                                    {cms.label_english}
                                  </option>
                                  <option value="spa" className="es-flag">
                                    {cms.label_spanish}
                                  </option>
                                </select>
                                {/* Menu toggle */}
                                <nav role="navigation">
                                    <div
                                      id="menuToggleLogin"
                                      aria-label={cms.label_508_menu}
                                      tabIndex="0"
                                    >
                                      <button
                                        onClick={handleMenu}
                                        style={{ border: "none", background: "transparent", padding: 0 }}
                                        aria-label="Open menu"
                                        aria-expanded={menuToggle}
                                        tabIndex={0}
                                      >
                                        {urlCarrier === 'bcbsaz' ? (
                                          <img
                                            src={`${process.env.PUBLIC_URL}/images/icons/Menu-bcbsaz.svg`}
                                            alt="Menu"
                                            className="menu-icon-bcbsaz"
                                          />
                                        ) : (
                                          <i className="fe fe-menu login-menu-hamburger" aria-hidden="true"></i>
                                        )}
                                      </button>
                                      <div id="menuLogin" ref={menuContainerRef} className={menuToggle ? "open" : ""}>
                                        {/* Hamburger toggle at top-right of open panel – matches HeaderPayment pattern */}
                                        <button
                                          onClick={handleMenu}
                                          className="menu-close-btn"
                                          aria-label="Close menu"
                                        >
                                          {urlCarrier === 'bcbsaz' ? (
                                            <img
                                              src={`${process.env.PUBLIC_URL}/images/icons/Menu-bcbsaz.svg`}
                                              alt="Menu"
                                              className="menu-icon-bcbsaz"
                                            />
                                          ) : (
                                            <>
                                              <span></span>
                                              <span></span>
                                              <span></span>
                                            </>
                                          )}
                                        </button>
                                        <ul className="menu-links-list">
                                          <li>
                                            <a
                                              href={
                                                cms?.limited_english_proficiency_link &&
                                                cms.limited_english_proficiency_link.trim() !== ""
                                                  ? `${cms?.limited_english_proficiency_link}`
                                                  : `${baseUrl}/${urlCarrier}/language_proficiency`
                                              }
                                              className="text-decoration-none"
                                              rel="noopener noreferrer"
                                            >
                                              {cms.limited_english_proficiency_link_name}
                                            </a>
                                          </li>
                                          <li>
                                            <a
                                              href={
                                                cms?.non_discrimination_notice_link &&
                                                cms.non_discrimination_notice_link.trim() !== ""
                                                  ? `${cms?.non_discrimination_notice_link}`
                                                  : `${baseUrl}/${urlCarrier}/language_proficiency`
                                              }
                                              className="text-decoration-none"
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              {cms.non_discrimination_notice_link_name}
                                            </a>
                                          </li>
                                          <li>
                                            <a
                                              href={`${baseUrl}/${urlCarrier}/contact_us`}
                                              className="text-decoration-none"
                                              rel="noopener noreferrer"
                                            >
                                              {cms.contact_us_link_name}
                                            </a>
                                          </li>
                                          <li>
                                            <a
                                          href={
                                            cms?.faq_link &&
                                            cms.faq_link.trim() !== ""
                                              ? `${cms?.faq_link}`
                                              : `${baseUrl}/${urlCarrier}/faq`
                                          }
                                          className="text-decoration-none"
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          {cms.faq_link_name}
                                        </a>
                                          </li>
                                          <li>
                                            <a
                                              href={`${baseUrl}/${urlCarrier}/glossary`}
                                              className="text-decoration-none"
                                              rel="noopener noreferrer"
                                            >
                                              {cms.glossary_acrn_link_name}
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </nav>
                              </div>
                              {/* <ul className="navbar-nav me-auto mb-2 mb-lg-0 float-end ">
                              <li className="nav-item dropdown">
                                <button
                                  className="nav-link dropdown-toggle language-dropdown text-center"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                  onClick={handleLanguageEn}
                                >
                                  <img
                                    src={`${process.env.PUBLIC_URL}/images/icons/US-flag.svg`}
                                    className="me-2"
                                    width="17"
                                    height="17"
                                    alt=""
                                  />
                                  <span className="h6 fw-semibold">
                                    {cms.label_english && cms.label_english}
                                  </span>
                                </button>
                                <ul className="dropdown-menu dropdown-menus">
                                  <li>
                                    <button
                                      className="dropdown-item hvr-bounce-to-right"
                                      onClick={handleLanguageEs}
                                    >
                                      <img
                                        src={`${process.env.PUBLIC_URL}/images/icons/Spain-Flag.svg`}
                                        className="me-2"
                                        width="17"
                                        height="17"
                                        alt=""
                                      />
                                      {cms.label_spanish}
                                    </button>
                                  </li>
                                </ul>
                              </li>
                            </ul>*/}
                            </div>

                            <div className="col-12">
                              <div className="mt-4">
                                <h2
                                  className="text-left fw-semibold primary-color"
                                  tabIndex="0"
                                >
                                  {cms.label_welcome}
                                  <br />
                                  {cms.label_portal_name}
                                </h2>
                                <h4
                                  className="mt-3 fs-form-label pb-0"
                                  tabIndex="0"
                                >
                                  {cms.label_subscriber_desc}
                                </h4>
                              </div>

                              <span className={`${showErr}`}>{errorText}</span>
                            </div>
                          </div>
                          <Form
                            noValidate
                            validated={validated}
                            onSubmit={handleSubmit}
                            ref={formRef}
                          >
                            <Row className="mt-0 gy-3 ">
                              <Form.Group
                                as={Col}
                                mb="2"
                                md="12"
                                controlId="validationCustom01"
                              >
                                <div className="form-floating mb-2">
                                  <Form.Control
                                    required
                                    type="text"
                                    name="memberId"
                                    className={`${inputInvalidStyle} form-control`}
                                    placeholder="XXXX"
                                    value={memberId}
                                    minLength="4"
                                    isInvalid={!!ssnMemberIdErr}
                                    isValid={
                                      memberIdTouched &&
                                      isMemberIdValid &&
                                      !ssnMemberIdErr
                                    }
                                    onChange={handleMemberID}
                                    disabled={loading}
                                    aria-label={cms.label_508_ssn_memberid}
                                    aria-describedby="memberIdHelp"
                                  />
                                  <Form.Label>
                                    <img
                                      src={
                                        urlCarrier === "bcbsaz"
                                          ? `${process.env.PUBLIC_URL}/images/icons/icon-address-bcbsaz.svg`
                                          : `${process.env.PUBLIC_URL}/images/icons/icon-address.svg`
                                      }
                                      className="me-2"
                                      width="20"
                                      height="20"
                                      alt="memberid"
                                    />
                                    {cms.label_ssn_memberid}{" "}
                                    <span className="text-danger">*</span>
                                  </Form.Label>
                                  <Form.Text
                                    id="memberIdHelp"
                                    aria-live="polite"
                                    className="text-muted"
                                    style={{ display: "none" }}
                                  >
                                    {cms.label_508_ssn_memberid}
                                  </Form.Text>
                                  <Form.Control.Feedback type="invalid">
                                    {ssnMemberIdErr}
                                  </Form.Control.Feedback>
                                </div>
                              </Form.Group>

                              <Form.Group
                                as={Col}
                                mb="2"
                                md="12"
                                controlId="validationCustom02"
                                className="dob-date-wrapper"
                              >
                                <div
                                  className="mb-2 form-floating dob-date"
                                  tabIndex="0"
                                  aria-label={cms.label_508_dob}
                                  aria-labelledby="dobHelp"
                                >
                                  <DatePicker
                                    required
                                    value={dob}
                                    selected={dob}
                                    onChange={handleDOB}
                                    className={`form-control custom-datepicker ${
                                      showDateErr === "show-date-err"
                                        ? "is-invalid"
                                        : dobTouched && isDOBValid
                                        ? "is-valid"
                                        : ""
                                    }`}
                                    popperProps={{
                                      strategy: "fixed", // use this to make the popper position: fixed
                                    }}
                                    popperPlacement="bottom-start"
                                    dateFormat="MM/dd/yyyy"
                                    minDate={new Date(1900, 1, 1)}
                                    maxDate={new Date()}
                                    showYearDropdown
                                    yearDropdownItemNumber={150}
                                    scrollableYearDropdown
                                    disabled={loading}
                                  ></DatePicker>
                                  <Form.Label>
                                    <img
                                      src={
                                        urlCarrier === "bcbsaz"
                                          ? `${process.env.PUBLIC_URL}/images/icons/calendar-bcbsaz.svg`
                                          : `${process.env.PUBLIC_URL}/images/icons/calendar.svg`
                                      }
                                      className="me-2"
                                      width="20"
                                      height="20"
                                      alt="calendar"
                                    />
                                    {cms.label_dob}{" "}
                                    <span className="text-danger">*</span>
                                  </Form.Label>
                                  <Form.Text
                                    id="dobHelp"
                                    aria-live="polite"
                                    className="text-muted"
                                    style={{ display: "none" }}
                                  >
                                    {cms.label_508_dob}
                                  </Form.Text>
                                </div>
                                <div
                                  className={`invalid-feedback ${showDateErr}`}
                                >
                                  {cms.invalid_dob}
                                </div>
                              </Form.Group>

                              <Form.Group
                                as={Col}
                                md="12"
                                mb="2"
                                controlId="validationCustom03"
                              >
                                <div className="form-floating mb-2">
                                  <Form.Control
                                    type="text"
                                    pattern="[0-9]*"
                                    value={zip}
                                    onChange={handleZip}
                                    placeholder="12345"
                                    minLength="5"
                                    maxLength="5"
                                    isInvalid={!!zipErr}
                                    isValid={
                                      zipTouched && isZipValid && !zipErr
                                    }
                                    required
                                    disabled={loading}
                                    aria-label={cms.label_508_zip}
                                    aria-describedby="zipHelp"
                                  />
                                  <Form.Label>
                                    <img
                                      src={
                                        urlCarrier === "bcbsaz"
                                          ? `${process.env.PUBLIC_URL}/images/icons/map-bcbsaz.svg`
                                          : `${process.env.PUBLIC_URL}/images/icons/map.svg`
                                      }
                                      className="me-2"
                                      width="20"
                                      height="20"
                                      alt="zipcode"
                                    />
                                    {cms.label_zip}{" "}
                                    <span className="text-danger">*</span>
                                  </Form.Label>
                                  <Form.Text
                                    id="zipHelp"
                                    aria-live="polite"
                                    className="text-muted"
                                    style={{ display: "none" }}
                                  >
                                    {cms.label_508_zip}
                                  </Form.Text>
                                  <Form.Control.Feedback type="invalid">
                                    {zipErr}
                                  </Form.Control.Feedback>
                                </div>
                              </Form.Group>

                              {/* <Form.Group
                              as={Col}
                              md="12"
                              mb="3"
                              controlId="validationCustom04"
                            >
                              <div className="form-check form-switch agree-check">
                                {/*<input
                                className="form-check-input"
                                type="checkbox"
                                required
                                value={agree}
                                checked={agree}
                                onChange={handleCheckBox}
                                disabled={loading}
                                isInvalid={!agree}
                              ></input>*/}
                              {/* <Form.Control
                                  type="checkbox"
                                  className="form-check-input agree-input"
                                  required
                                  value={agree}
                                  checked={agree}
                                  onChange={handleCheckBox}
                                  disabled={loading}
                                  isInvalid={!agree}
                                />
                                <Form.Label className="col-10 mt-2 col-xl-11 col-md-10">
                                  <h6 className="fs-form-label ms-2">
                                    {cms.label_agree}{" "}
                                    <span className="fw-bold primary-color">
                                      {cms.label_terms}{" "}
                                    </span>
                                    {cms.label_and}{" "}
                                    <span className="fw-bold primary-color">
                                      {cms.label_privacy}
                                    </span>
                                  </h6>
                                </Form.Label>

                                <Form.Control.Feedback type="invalid">
                                  {cms.invalid_agree}
                                </Form.Control.Feedback>
                              </div>
                            </Form.Group>*/}
                            </Row>
                            <div className="col-12 mb-4 mt-3">
                              <div className="d-grid">
                                <input
                                  type="submit"
                                  value={labelSignIn}
                                  className="d-grid btn btn-dark login-btn-lg"
                                  disabled={loading}
                                  aria-label={cms.label_508_sign_in}
                                />
                              </div>
                            </div>
                          </Form>
                          {loading && (
                            <div className="d-flex justify-content-center mt-3">
                              <Spinner animation="border" role="status" />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <Toast
              message={toastMessage}
              showToast={showToast}
              closeToast={() => setShowToast(false)}
              type={toastType}
            />*/}
              <ToastContainer></ToastContainer>
            </div>
          </div>
          /* )*/
        }
      </section>
    </div>
    </>
  );
}
